module.exports = __webpack_public_path__ + "img/halloween-orange.babd35d2.svg";